import axios from 'axios';
import qs from 'qs';
import { IOrder } from '@@functions/models';


// staging
const jc_pack_api = process.env.VUE_APP_JC_PACK_API;
const jc_auction_api = process.env.VUE_APP_JC_AUCTION_API;
const api_token = process.env.VUE_APP_API_TOKEN;
const username_get_token =  process.env.VUE_APP_USERNAME_GET_TOKEN
const password_get_token =  process.env.VUE_APP_PASSWORD_GET_TOKEN

export default {
  getTokenAccessJPC() {
    const data = {
      username: username_get_token,
      password: password_get_token,
      grant_type: 'password',
    };
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: api_token + '/oauth/token',
        data: qs.stringify(data),
        headers: {
          Authorization: 'Basic SlBDX0lEOkpQQ19PQVVUSA==',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        auth: {
          username: 'JPC_ID',
          password: 'JPC_OAUTH',
        },
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  getTotalTransportByMatterNo(token: string, matterNo: string) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          jc_pack_api +
          '/api/admin/transport/transportation/total-transport-by-matterNo/' +
          matterNo,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  getTransportRequest(token: string, data: string) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: jc_pack_api + '/api/admin/transport/transportation/transport-request',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: data,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  addOrUpdateTransport(token: string, item: IOrder) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url:
          jc_pack_api +
          '/api/admin/transport/transport-order-detail/add-or-update-transport-rikuso',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: item,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  //20220324 Task166 start
  requestUpdateTransport(token: string, data: any) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url:
          jc_pack_api +
          '/api/admin/transport/transport-order-detail/update-vinno-transport-rikuso',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: data,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  //20220324 Task166 end
  //20220426 Task188 start
  requestUpdateCRM(data: any, token: string) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: jc_pack_api + '/api/admin/transport/transport-order/request-crm',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: data,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  getAuctionOderByMatterNo(token: string, matterNo: string) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: jc_auction_api + '/api/user/manage/auction/auction-place/' + matterNo,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  // 20220426 Task188 end
  //20220506 Task192 start
  getListTransportOderByMatterNo(token: string, data: any) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url:
          jc_pack_api + '/api/admin/transport/transport-order-detail/get-list-transport',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: data,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  //20220506 Task192 end
  //20220510 Task186 start
  createListTransport(token: string, data: any) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url:
          jc_pack_api +
          '/api/admin/transport/transport-order-detail/create-list-transport',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: data,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  //20220510 Task186 end
  //20220517 Task197 start
  getListCustomerInf(token: string) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          jc_pack_api + '/api/admin/transport/transport-order-detail/get-list-customer',
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  //20220517 Task197 end
  //task-258-start
  requestUpdateTransportRequest(token: string, data: any) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url:
          jc_pack_api +
          '/api/admin/transport/transport-order-detail/update-transport-rikuso',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: data,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  //Start QuocNV 03102023 add new api screen astimation
  getListCompanyFee(token: string, data: any) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          jc_pack_api + (data.isSearchAuction === 0 ? '/api/admin/convert-kintone/get-list-company-fee' : '/api/admin/convert-kintone/get-list-company-fee-yarn-to-yarn'),
        headers: {
          Authorization: 'Bearer ' + token,
        },
        params: {
          auctionPlaceId: data.auctionPlaceId,
          satelliteId: data.satelliteId,
          yardRecordId: data.yardRecordId,
          customerId: data.customerId
        },
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  getFeeByCustomer(token: string, data: any) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url:
          jc_pack_api + (data.isSearchAuction === 0 ? '/api/admin/convert-kintone/get-fee-by-customer' : '/api/admin/convert-kintone/get-fee-by-customer-yarn-to-yarn'),
        headers: {
          Authorization: 'Bearer ' + token,
        },
        params: {
          auctionPlaceId: data.auctionPlaceId,
          satelliteId: data.satelliteId,
          yardRecordId: data.yardRecordId,
          customerId: data.customerId
        },
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  updateFeeCompany(token: string, data:any){
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url:
          jc_pack_api +
          '/api/admin/convert-kintone/update-fee-company',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: data,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  updateFeeBase(token: string, data:any){
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url:
          jc_pack_api +
          '/api/admin/convert-kintone/update-fee-base',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: data,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  updateFeeCustomer(token: string, data:any){
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url:
          jc_pack_api +
          '/api/admin/convert-kintone/update-fee-customer',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: data,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  //END QuocNV 03102023 add new api screen astimation
  //START QUOCNV 08112023 add new api delete transport from rikuso
  deleteTransport(token: string, data:any){
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url:
          jc_pack_api +
          '/api/admin/convert-kintone/delete-transport',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: data,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  //END QUOCNV 08112023 add new api delete transport from rikuso

  // START QuocNV 20231117 add new api update fee rikuso 
  updateTransportFeeRikuso(token: string, data:any){
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url:
          jc_pack_api +
          '/api/admin/convert-kintone/update-fee-rikuso',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: data,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  // END QuocNV 20231117 add new api update fee rikuso 
  //START QUocNV 20231130 add api update transport detail id to rikuso
  updateTransportDetailIdToRikuso(token: string, item: IOrder) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'PUT',
        url:
          jc_pack_api +
          '/api/admin/convert-kintone/update-transport-detail-id-rikuso',
        headers: {
          Authorization: 'Bearer ' + token,
        },
        data: item,
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(err));
    });
  },
  //END QUocNV 20231130 add api update transport detail id to rikuso
  checkPaymentPriceRikuso(token: string, transportDetailId: string) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'GET',
        url: jc_pack_api + '/api/admin/check-invoice-parent/' + transportDetailId,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      })
        .then((resp) => resolve(resp.data))
        .catch((err) => reject(false));
    });
  },
};
